// extracted by mini-css-extract-plugin
export default {"radio":"jLNVFc","checked":"U5s3gt"};